// Blog List Page - Shows all blogs for a category
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import '../../App.css';
import './BlogList.css';
import Footer from '../Footer';

export default function BlogList() {
  const { category } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    fetchBlogs();
  }, [category]);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      // TODO: Replace with actual Azure Blob Storage API call
      const response = await fetch(`/api/blogs?category=${category}`);
      if (response.ok) {
        const data = await response.json();
        setBlogs(data);
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
      // Mock data for development
      setBlogs([
        {
          id: '1',
          title: 'Getting Started with Azure',
          excerpt: 'Learn the basics of Azure cloud computing...',
          category: 'azure',
          tags: ['azure', 'cloud', 'beginner'],
          createdAt: '2026-03-15',
          author: 'Admin'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const filteredBlogs = blogs.filter(blog => {
    const matchesSearch = blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         blog.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesTags = selectedTags.length === 0 || 
                       selectedTags.some(tag => blog.tags.includes(tag));
    return matchesSearch && matchesTags;
  });

  const categoryTitle = category === 'azure' ? 'Azure' : category === 'ai' ? 'AI' : category === 'm365' ? 'M365' : category === 'general' ? 'General' : 'All Content';
  const categoryColor = category === 'azure' ? '#0078D4' : category === 'ai' ? '#FF6B6B' : category === 'general' ? '#9B59B6' : '#7FBA00';

  return (
    <>
      <div className="blog-list-container">
        <div className="blog-list-header" style={{ borderBottomColor: categoryColor }}>
          <h1>{categoryTitle} Content</h1>
          <div className="blog-search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {isAuthenticated && (
            <Link to={`/blog/create?category=${category}`} className="btn-create-blog">
              <i className="fas fa-plus"></i> Create New Post
            </Link>
          )}
        </div>

        {loading ? (
          <div className="loading">Loading content...</div>
        ) : filteredBlogs.length === 0 ? (
          <div className="no-blogs">
            <i className="fas fa-inbox"></i>
            <p>No articles found. {isAuthenticated && 'Be the first to create one!'}</p>
          </div>
        ) : (
          <div className="blogs-grid">
            {filteredBlogs.map(blog => (
              <Link to={`/blog/${blog.id}`} key={blog.id} className="blog-card">
                {blog.thumbnail && (
                  <div className="blog-card-thumbnail">
                    <img src={blog.thumbnail} alt={blog.title} style={{ objectPosition: `center ${blog.thumbnailPosition ?? 50}%` }} />
                  </div>
                )}
                <div className={`blog-card-body${blog.thumbnail ? '' : ' blog-card-body--no-thumb'}`}>
                  <div className="blog-card-author-row">
                    {blog.authorId
                      ? <img src={`/api/profile-avatar?userId=${blog.authorId}`} alt={blog.author} className="blog-card-author-avatar" onError={e => { e.target.style.display='none'; }} />
                      : <i className="fas fa-user-circle blog-card-author-icon"></i>
                    }
                    <span className="blog-card-author-name">{blog.author}</span>
                    <span className="blog-card-author-sep">·</span>
                    <span className="blog-card-date">{new Date(blog.createdAt).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                  </div>
                  <h2>{blog.title}</h2>
                  <p className="blog-excerpt">{blog.excerpt}</p>
                  <div className="blog-tags">
                    {blog.tags.map(tag => (
                      <span key={tag} className="blog-tag">#{tag}</span>
                    ))}
                  </div>
                  <div className="blog-footer">
                    <span className="blog-category" style={{ backgroundColor: categoryColor }}>
                      {blog.category.toUpperCase()}
                    </span>
                    <span className="blog-read-more">
                      Read More <i className="fas fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
